import { IssueTaskDoc } from '@gooduncles/gu-app-schema';
import { InventoryIssueRow } from './types';

/**
 * IssueTaskDoc 배열을 InventoryIssueRow 배열로 변환
 * - inventoryIssueInfo가 있는 Task만 처리
 * - 각 Task의 products를 기준으로 row를 평탄화
 *
 * @param tasks - IssueTaskDoc 배열
 * @returns InventoryIssueRow 배열
 */
export const transformToInventoryIssueRows = (tasks: IssueTaskDoc[]): InventoryIssueRow[] => {
  return tasks
    .filter((task) => task.inventoryIssueInfo !== null && task.products && task.products.length > 0)
    .flatMap((task) => {
      const { inventoryIssueInfo, products } = task;
      if (!inventoryIssueInfo || !products) return [];

      return products.map((product): InventoryIssueRow => {
        const productInfo = inventoryIssueInfo.products[product.productId] || {
          status: 'pending' as const,
          inventoryIssueId: null,
          processedAt: null,
        };

        return {
          rowId: `${task._id}_${product.productId}`,
          taskId: task._id,
          issueCaseId: task.issueCaseId,
          category: task.category,
          taskStatus: task.status,
          storeId: task.storeId,
          storeName: task.storeName,
          registeredAt: task.registeredAt,
          targetDate: task.targetDate,
          finishedAt: task.finishedAt,
          caseSourceReferenceDate: task.caseSourceReferenceDate,
          productId: product.productId,
          productName: product.productName,
          inventoryId: product.inventoryId,
          quantity: product.quantity,
          price: product.price,
          inventoryStatus: productInfo.status,
          inventoryIssueId: productInfo.inventoryIssueId,
          processedAt: productInfo.processedAt,
          _originalTask: task,
        };
      });
    });
};

/**
 * inventoryIssueInfo가 있는 Task만 필터링
 */
export const filterTasksWithInventoryIssueInfo = (tasks: IssueTaskDoc[]): IssueTaskDoc[] => {
  return tasks.filter((task) => task.inventoryIssueInfo !== null);
};
